export default __webpack_public_path__ + "media/images/hero-13d696180d0ac449fad18aad5c13c436.jpg";